import React from 'react';
import { Form } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { firstError, findError, validationClasses } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import fields from '@/constants/fields';
import FormValidationError from '@/components/errors/FormValidationError';
import MarkdownEditor from '@/components/text-editors/MarkdownEditor';
import { updateActiveVocabularyProperties } from '../actions';

const VocabularyMarkdownForm = ({
  submitForm,
  updateProperties,
  updateErrors,
  updateStatus,
  text,
}) => {
  const valueError = findError(updateErrors, 'vocabulary', [fields.VALUE]);

  return (
    <div className="content">
      <Form autoComplete="off" onSubmit={submitForm} error={firstError(updateErrors) !== null}>
        <FormValidationError error={valueError} htmlFor="vocabulary_value" position="bottom left">
          <MarkdownEditor
            autoFocus
            className={validationClasses(valueError)}
            disabled={updateStatus === states.PENDING}
            id="vocabulary_value"
            maxEditorHeight={80}
            minPreviewHeight={94}
            onChange={(value) => updateProperties({ value })}
            tools={[['bold', 'italic'], ['link']]}
            value={text}
          />
        </FormValidationError>
      </Form>
    </div>
  );
};

const mapStateToProps = ({
  vocabularies: { activeVocabulary: { updateErrors, updateStatus, value } },
}) => ({
  updateErrors, updateStatus, text: value,
});

const mapDispatchToProps = {
  updateProperties: updateActiveVocabularyProperties,
};

export default connect(mapStateToProps, mapDispatchToProps)(VocabularyMarkdownForm);
